<template>
    <div v-html="temp" />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import HelloWorld from '../../components/HelloWorld.vue';
import {privacyConfig} from '@/config/template';
import {DataUtil} from '@/util/DataUtil';

@Options({
  components: {
    HelloWorld,
  }
})
export default class App extends Vue {
    private temp: string = privacyConfig.template_0526;

    private config: TemplateInterface = {
      productName: '找茬天天乐',
      companyFullName: '天津文远科技有限公司',
      companyShortName: '天津文远',
      officialWebsite: 'http://www.hainanyicheng.com/',
      sdkWebsite: 'https://www.wenyuankeji.com.cn/third/thirdPage.html'
    };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
}
</script>

<style lang="less">
    #app {

    }
</style>
